import { ReloadOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { t } from "i18next";
import * as React from "react";
import { onError } from "src/common/onError";

import { RtCtrlLoad } from "../../ctrl";
import { AbstractFilters } from "../../RtTypes";

type PropsRtReloadButton = {
  store: Pick<RtCtrlLoad<AbstractFilters>, "reload">;
};

export const RtReloadButton: React.FC<PropsRtReloadButton> = ({ store }) => (
  <Button
    icon={<ReloadOutlined />}
    onClick={() => store.reload().catch(onError)}
    title={t("Reload")}
  />
);
